import { createContext, useState, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components'
import { ThemeLight } from './ThemeLight';
import { ThemeDark } from './ThemeDark';

export const ThemeContext = createContext<IProviderStyle>({});

export type IProviderStyle = {
  children?: ReactNode,
  alterTheme?: VoidFunction
  selectTheme?: { name: String, color: String, text: String }
}

const theme = {
  dark: {
   ...ThemeDark
  },
  light: {
    ...ThemeLight
  }
}

export default function ProviderStyle({ children }: IProviderStyle) {

  const [selectTheme, setTheme] = useState(localStorage.getItem('theme') == "light" ? theme.dark : theme.light);

  function alterTheme() {
    setTheme((value) => localStorage.getItem('theme') == "light" ? theme.dark : theme.light)
  }

  return (
    <ThemeContext.Provider value={{ alterTheme, selectTheme }}>
      <ThemeProvider theme={selectTheme}>
        {
          children
        }
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}
